import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat',
    standalone: false
})
export class PhoneFormatPipe implements PipeTransform {

  transform(phoneNumber: string, countryCode: string = ''): string {
    if (!phoneNumber) {
      return '';
    }

    // Remove any non-digit characters
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Format the phone number based on its length
    if (cleanedNumber.length <= 6) {
      return cleanedNumber;
    } else if (cleanedNumber.length <= 10) {
      // Format as XX-XXXXX
      const firstPart = cleanedNumber.slice(0, 2);
      const secondPart = cleanedNumber.slice(2);
      return `${firstPart}-${secondPart}`;
    } else {
      // Format as XXXXX-XXXXX
      const firstPart = cleanedNumber.slice(0, 5);
      const secondPart = cleanedNumber.slice(5, 10);
      const remainingPart = cleanedNumber.slice(10);
      
      if (remainingPart) {
        return `${firstPart}-${secondPart}-${remainingPart}`;
      } else {
        return `${firstPart}-${secondPart}`;
      }
    }
  }

  // Combine country code and phone number with proper formatting
  static formatPhoneWithCountryCode(countryCode: string, phoneNumber: string): string {
    if (!phoneNumber) {
      return countryCode || '';
    }

    // Ensure country code has a plus if needed
    const formattedCountryCode = countryCode ? 
      (countryCode.startsWith('+') ? countryCode : `+${countryCode}`) : '';
    
    // Remove any non-digit characters from phone number
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Format based on length
    let formattedNumber = '';
    
    if (cleanedNumber.length <= 6) {
      formattedNumber = cleanedNumber;
    } else if (cleanedNumber.length <= 10) {
      const firstPart = cleanedNumber.slice(0, 5);
      const secondPart = cleanedNumber.slice(5);
      formattedNumber = `${firstPart}-${secondPart}`;
    } else {
      const firstPart = cleanedNumber.slice(0, 5);
      const secondPart = cleanedNumber.slice(5, 10);
      const remainingPart = cleanedNumber.slice(10);
      
      if (remainingPart) {
        formattedNumber = `${firstPart}-${secondPart}-${remainingPart}`;
      } else {
        formattedNumber = `${firstPart}-${secondPart}`;
      }
    }
    
    return formattedCountryCode ? `${formattedCountryCode}-${formattedNumber}` : formattedNumber;
  }
} 